<h4 class="ib-heading ib-heading--type-4 ib-summary__section-title" [innerHTML]="'ANCILLARIES_GLOBICK_ACTIVITIES_TITLE'|translate">
</h4>
<div class="ib-summary-item__item">
    <div *ngFor="let item of model?.info.description; index as i"
        class="ib-list-passengers__item-description ib-list-passengers__item-description--long ib-list-passengers__item-description--long-start u-pb-small">
        <span class="ib-text ib-text--color-unfocused">
            <span class="u-display-block">{{ model?.info.description[i] }}</span>
            <span class="u-display-block">{{ model?.info.date[i] }}</span>
        </span>
        <span class="ib-text ib-text--color-normal"> {{ model?.info.totalFormatted[i] }}</span>
    </div>
</div>
<div class="ib-summary__subtotal ib-summary__subtotal--separator">
    <span class="ib-text ib-text--block ib-text--bold" [innerHTML]="'HEADER_BASKET_GLOBICK_ACTIVITY_AMOUNT'|translate"></span>
    <span class="ib-text ib-text--block ib-text--bold">{{ model?.total.totalFormatted}}</span>
</div>
